import React from 'react';
import { Plus, FileText } from 'lucide-react';

export default function DocumentoItemForm({ 
  itemActual, 
  handleItem, 
  agregarItem, 
  isAgregado,
  TIPOS_DOCUMENTO,
  REGISTROS,
  getRegistrosPorTipo
}) {
  const registrosDisponibles = typeof getRegistrosPorTipo === 'function'
    ? getRegistrosPorTipo(itemActual?.tipo_documento)
    : REGISTROS;

  return (
    <div style={{ background: '#fff', borderRadius: '12px', border: '1px solid #e2e8f0', borderLeft: '6px solid #0f172a', padding: '1.5rem', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', marginBottom: '1.5rem' }}>
      <h3 style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#0f172a', fontSize: '1.1rem', fontWeight: '700', marginBottom: '1.5rem', marginTop: 0 }}>
        <FileText size={20} color="#0f172a" />
        Datos del Documento (Foja y Vuelta)
      </h3>
      
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))', gap: '1rem', alignItems: 'end', marginBottom: '1.5rem' }}>
        <div style={{ gridColumn: 'span 2' }}>
          <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: '#334155', marginBottom: '0.4rem' }}>Tipo Documento</label>
          <select 
            name="tipo_documento" 
            value={itemActual.tipo_documento} 
            onChange={handleItem}
            style={{ width: '100%', padding: '10px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '0.9rem', outline: 'none', background: '#fff' }}
          >
            {TIPOS_DOCUMENTO.map((t) => <option key={t}>{t}</option>)}
          </select>
        </div>

        {!isAgregado && (
          <>
            <div>
              <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: '#334155', marginBottom: '0.4rem' }}>Foja</label>
              <input 
                name="foja" 
                value={itemActual.foja} 
                onChange={handleItem} 
                placeholder="120" 
                style={{ width: '100%', padding: '10px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '0.9rem', outline: 'none' }}
              />
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: '#334155', marginBottom: '0.4rem' }}>Fojas (Reverso)</label>
              <label style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                cursor: 'pointer', fontSize: '0.9rem', fontWeight: 600,
                background: '#fff',
                color: '#334155',
                border: '1px solid #cbd5e1',
                borderRadius: '6px', padding: '9px 12px', userSelect: 'none'
              }}>
                <input
                  type="checkbox"
                  name="vta"
                  checked={itemActual.vta}
                  onChange={handleItem}
                  style={{ width: '16px', height: '16px', margin: 0 }}
                />
                VTA (Vuelta)
              </label>
            </div>
          </>
        )}

        <div>
          <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: '#334155', marginBottom: '0.4rem' }}>Número</label>
          <input 
            type="text" 
            name="numero" 
            value={itemActual.numero} 
            onChange={handleItem} 
            placeholder="45" 
            style={{ width: '100%', padding: '10px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '0.9rem', outline: 'none' }}
          />
        </div>
        
        <div>
          <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: '#334155', marginBottom: '0.4rem' }}>Año</label>
          <input 
            type="number" 
            name="anio" 
            value={itemActual.anio} 
            onChange={handleItem} 
            placeholder="2023" 
            style={{ width: '100%', padding: '10px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '0.9rem', outline: 'none' }}
          />
        </div>
        
        <div style={{ gridColumn: 'span 2' }}>
          <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: '#334155', marginBottom: '0.4rem' }}>Registro *</label>
          <select 
            name="registro" 
            value={itemActual.registro} 
            onChange={handleItem}
            style={{ width: '100%', padding: '10px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '0.9rem', outline: 'none', background: '#fff' }}
          >
            <option value="">Seleccione un registro...</option>
            {registrosDisponibles.map((r) => <option key={r} value={r}>{r}</option>)}
          </select>
        </div>
      </div>
      
      <div style={{ display: 'flex' }}>
        <button 
          onClick={agregarItem} 
          style={{ 
            display: 'flex', alignItems: 'center', gap: '8px', 
            background: '#fff', color: '#0f172a', border: '1px solid #94a3b8', 
            padding: '8px 16px', borderRadius: '6px', fontSize: '0.9rem', fontWeight: '600', 
            cursor: 'pointer' 
          }}
        >
          <Plus size={16} color="#0f172a" /> Agregar otro documento
        </button>
      </div>
    </div>
  );
}
